import { serviceTypes, modulesConfig } from '../config';

export const moduleId = 'Review';
export const modulePath = serviceTypes[modulesConfig.Review.serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
